// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationId: z.string().min(1).max(21),
    externalId: z.string().min(1).max(128),
    departmentId: z.string().min(1).max(21),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationId: z.string().min(1).max(21),
    externalId: z.string().min(1).max(128),
    departmentId: z.string().min(1).max(21),
});
export const OrganizationDirectoryDepartments = Object.freeze({
    table: 'organization_directory_departments',
    tableSingular: 'organization_directory_department',
    fields: {
        tenantId: 'tenant_id',
        organizationId: 'organization_id',
        externalId: 'external_id',
        departmentId: 'department_id',
    },
    fieldKeys: [
        'tenantId',
        'organizationId',
        'externalId',
        'departmentId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
